import request from '@/utils/request';

/**
 * 查询动作模板列表
 * @param {Object} data
 * @returns
 */
export function allListActionTemplate(data) {
  return request({
    url: '/admin/business/action/allList',
    method: 'POST',
    data,
  });
}

/**
 * 上传
 * @param {Object} data
 * @returns
 */
import Oss from 'ali-oss';
let isUploadCanceled = false;
export function ossUpload({ path, file }) {
  return new Promise((resolve, reject) => {
    request({
      url: '/ali/getStsToken',
      method: 'get',
    })
      .then(res => {
        const creditInfo = res.data;
        const aliOss = new Oss(creditInfo);
        aliOss
          .put(`${path}/${new Date().getTime()}/${file.name}`, file, {
            headers: {
              'Access-Control-Allow-Origin': '*',
            },
          })
          .then(uploadRes => {
            // resolve(uploadRes);
            if (!isUploadCanceled) {
              resolve(uploadRes);
            } else {
              reject(new Error('Upload canceled'));
            }
          })
          .catch(err => {
            reject(err);
          });
      })
      .catch(err => {
        reject(err);
      });
  });
}

export function ossMultipartUpload({ path, file, progress }) {
  return new Promise((resolve, reject) => {
    request({
      url: '/ali/getStsToken',
      method: 'get',
    })
      .then(res => {
        const creditInfo = res.data;
        const aliOss = new Oss(creditInfo);
        aliOss
          .multipartUpload(`${path}`, file, {
            progress: (p, cpt, res) => {
              // 为中断点赋值。
            //   abortCheckpoint = cpt;
            //   console.log(abortCheckpoint);
              // 获取上传进度。
              console.log(p * 100);
              if ((p*100) >= 100) {
                resolve(res);
              }
              progress(p, cpt, res)
            },
          })
          .catch(err => {
            reject(err);
          });
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 取消上传的方法
export function cancelUpload() {
  isUploadCanceled = true;
}
